<script lang="ts">
    import {CheckIcon} from "lucide-svelte";

    let {
        checked,
        onchange = () => {
        },
        label,
    }: {
        checked: boolean;
        onchange?: () => void;
        label: string;
    } = $props();

</script>
<label class="flex cursor-pointer items-center gap-3 text-[11px] font-semibold text-slate-700">
    <input
            type="checkbox"
            checked={checked}
            onchange={onchange}
            class="hidden"
    />
    <span class="checkbox h-5 w-5 rounded flex items-center justify-center"
          class:active={checked}
    >
        {#if checked}
        <CheckIcon size={16} color="white"/>
        {/if}
    </span>
    {label}
</label>

<style>
    @import "tailwindcss";

    .checkbox {
        border: 1px solid #CDB6E2;
    }

    .checkbox.active {
        background-color: #7C46AF;
    }

</style>
